import colors from 'quasar/src/utils/colors.js';;

export default {
  methods: {
    humanFilterStrength(value) {
      switch (true) {
        case value < 25:
          return {
            label: "Weak",
            color: "red-12",
            hexColor: colors.textToRgb(colors.getPaletteColor("red-12")),
          };

        case 25 <= value && value < 75:
          return {
            label: "Medium",
            color: "orange-7",
            hexColor: colors.textToRgb(colors.getPaletteColor("orange-7")),
          };

        case value >= 75:
          return {
            label: "Strong",
            color: "green",
            hexColor: colors.textToRgb(colors.getPaletteColor("green")),
          };
      }
    },
  },
};
